import { useForcedSchoolGradeModal } from '../hooks/useForcedSchoolGradeModal';

/**
 * 학교·학년 강제 모달 게이트. _app.page.tsx 에서만 전역 1회 마운트할 것 —
 * 다른 곳에서 훅을 또 호출하면 모달이 중복으로 열린다.
 */
export const ForcedSchoolGradeModalGate = () => {
  useForcedSchoolGradeModal();
  return null;
};